/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type DeleteMcpServerSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type DeleteMcpServerSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type DeleteMcpServerSecurity = {
  option1?: DeleteMcpServerSecurityOption1 | undefined;
  option2?: DeleteMcpServerSecurityOption2 | undefined;
};

export type DeleteMcpServerRequest = {
  /**
   * The ID of the MCP server to delete
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type DeleteMcpServerSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const DeleteMcpServerSecurityOption1$outboundSchema: z.ZodMiniType<
  DeleteMcpServerSecurityOption1$Outbound,
  DeleteMcpServerSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function deleteMcpServerSecurityOption1ToJSON(
  deleteMcpServerSecurityOption1: DeleteMcpServerSecurityOption1,
): string {
  return JSON.stringify(
    DeleteMcpServerSecurityOption1$outboundSchema.parse(
      deleteMcpServerSecurityOption1,
    ),
  );
}

/** @internal */
export type DeleteMcpServerSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const DeleteMcpServerSecurityOption2$outboundSchema: z.ZodMiniType<
  DeleteMcpServerSecurityOption2$Outbound,
  DeleteMcpServerSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function deleteMcpServerSecurityOption2ToJSON(
  deleteMcpServerSecurityOption2: DeleteMcpServerSecurityOption2,
): string {
  return JSON.stringify(
    DeleteMcpServerSecurityOption2$outboundSchema.parse(
      deleteMcpServerSecurityOption2,
    ),
  );
}

/** @internal */
export type DeleteMcpServerSecurity$Outbound = {
  Option1?: DeleteMcpServerSecurityOption1$Outbound | undefined;
  Option2?: DeleteMcpServerSecurityOption2$Outbound | undefined;
};

/** @internal */
export const DeleteMcpServerSecurity$outboundSchema: z.ZodMiniType<
  DeleteMcpServerSecurity$Outbound,
  DeleteMcpServerSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => DeleteMcpServerSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => DeleteMcpServerSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function deleteMcpServerSecurityToJSON(
  deleteMcpServerSecurity: DeleteMcpServerSecurity,
): string {
  return JSON.stringify(
    DeleteMcpServerSecurity$outboundSchema.parse(deleteMcpServerSecurity),
  );
}

/** @internal */
export type DeleteMcpServerRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const DeleteMcpServerRequest$outboundSchema: z.ZodMiniType<
  DeleteMcpServerRequest$Outbound,
  DeleteMcpServerRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function deleteMcpServerRequestToJSON(
  deleteMcpServerRequest: DeleteMcpServerRequest,
): string {
  return JSON.stringify(
    DeleteMcpServerRequest$outboundSchema.parse(deleteMcpServerRequest),
  );
}
